// extracted by mini-css-extract-plugin
export default {"list":"yTRc1","icon":"IBFRl","userMenuItem":"rq7sc","popup":"qA790","count":"sqBYZ","favorites":"H9FpJ"};